import EventEmitter from '../events'
class LocalStorage extends EventEmitter {
  getItem (key:string) {
    return window.localStorage.getItem(key)
  }

  setItem (key:string, value:string) {
    const oldV = this.getItem(key)
    window.localStorage.setItem(key, value)
    // 触发监听
    this.emit(key, value, oldV)
  }

  clear () {
    Object.keys(window.localStorage).forEach((key:string) => {
      const oldV = this.getItem(key)
      // 触发监听
      this.emit(key, null, oldV)
    })
    window.localStorage.clear()
  }

  removeItem (key:string) {
    const oldV = this.getItem(key)
    // 触发监听
    if (oldV) {
      this.emit(key, null, oldV)
    }
    window.localStorage.removeItem(key)
  }

  key (index:number) {
    return window.localStorage.key(index)
  }
}

export default new LocalStorage()